export default __webpack_public_path__ + "static/media/webgpu-today.088c61a3.svg";